<template>
  <div>
    <v-card v-if="smsCredits == null">
      <v-row align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          Getting Your Credits
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            :color="getThemeColor"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-else-if="!smsCredits && smsCredits < 1">
      <v-row class="fill-height">
        <CardAlert color="error" class="my-6 mx-auto fill-width">
          <h3>Balance Left: {{ smsCredits }}</h3>
          <br />
          <h5>
            Contact Kenny for Credits <br />
            Call/WhatsApp 076 243 9441
          </h5>
        </CardAlert></v-row
      ></v-card
    >
    <v-card v-else-if="smsCredits && smsCredits > 0">
      <v-card-text>
        <v-text-field
          v-if="recipientsIDs.length < 1"
          v-model="customNumbers"
          label="Numbers eg. 076 243 9441 , 081 482 6615 "
          class="mx-4"
        ></v-text-field>
        <v-autocomplete
          :items="['Now', 'Future']"
          v-model="timeToSend"
          @change="decideTiming()"
          class="mx-4"
          label="When To Send SMS"
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="timeToSend == 'Future'"
          :items="[
            'Once',
            'Daily',
            'Weekly',
            'Fortnightly',
            'Monthly',
            'Quarterly',
            'Bi-Annually',
            'Yearly',
          ]"
          v-model="cycle"
          class="mx-4"
          label="When To Send SMS"
        >
        </v-autocomplete>
        <DatePickerWithMenu
          label="Date"
          v-if="timeToSend && timeToSend != 'Now'"
          @date-selected="getNoteDateSelected"
          :default="selectedDate"
        ></DatePickerWithMenu>

        <v-textarea
          dense
          rows="1"
          label="SMS Title"
          :readonly="predefine"
          v-model="noteTitle"
          class="mx-4"
        ></v-textarea>

        <v-textarea
          rows="3"
          label="SMS Body"
          v-model="noteBody"
          :readonly="predefine"
          class="mt-4 mx-4"
        ></v-textarea>
        <v-row>
          <v-spacer></v-spacer>

          <v-btn
            small
            color="green"
            @click="scheduleSMSSend()"
            rounded
            dark
            class="mr-4 mb-4"
            v-if="noteTitle && noteBody"
          >
            <v-icon x-small>mdi-check</v-icon>Send
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  props: ["recipientsIDs", "groupTable", "selectedSentSMSItem","predefine"],
  components: { DatePickerWithMenu, CardAlert },
  watch: {
    selectedSentSMSItem() {
      this.setResendData();
    },
  },
  mounted() {
    this.setResendData();
    this.getSMSCredits();
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  data: () => ({
    customNumbers: null,
    numbersArray: [],
    sentSMSID: null,
    smsCredits: null,
    title: null,
    noteTitle: null,
    noteBody: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    selectedNote: null,
    timeToSend: "Now",
    cycle: "Once",
  }),
  methods: {
    setResendData() {
      if (this.selectedSentSMSItem) {
        this.noteTitle = this.selectedSentSMSItem.title;
        this.noteBody = this.selectedSentSMSItem.body;
        this.selectedDate = this.selectedSentSMSItem.date_time;
        this.sentSMSID = this.selectedSentSMSItem.id;
      } else {
        this.noteTitle = null;
        this.noteBody = null;
        this.selectedDate = null;
        this.sentSMSID = null;
      }
    },
    getSMSCredits() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-sms-credits", this.getAccessToken)
        .then((credits) => {
          this.smsCredits = credits;
          this.$store.commit("setLoader", false);
        });
    },

    scheduleSMSSend() {
      this.$store.commit("setLoader", true);
      if (!this.selectedSentSMSItem && this.recipientsIDs.length < 1) {
        if (this.customNumbers.includes(",")) {
          this.numbersArray = this.customNumbers.split(",");
        } else {
          this.numbersArray = [this.customNumbers];
        }
      }

      if (this.timeToSend == "Future") {
        axios
          .postDataWithToken(
            "/auth/schedule-sms-for-future",
            {
              recipientsIDs: this.recipientsIDs,
              groupTable: this.groupTable,
              selectedDate: this.selectedDate,
              noteTitle: this.noteTitle,
              noteBody: this.noteBody,
              cycle: this.cycle,
              sentSMSID: this.sentSMSID,
              numbersArray: this.numbersArray,
            },
            this.getAccessToken
          )
          .then((response) => {
            this.sentSMSID = null;
            this.numbersArray = [];
            this.$store.commit("setLoader", false);
            this.$emit("refresh-needed");
          });
      } else {
        axios
          .postDataWithToken(
            "/auth/send-bulk-sms",
            {
              recipientsIDs: this.recipientsIDs,
              groupTable: this.groupTable,
              noteTitle: this.noteTitle,
              noteBody: this.noteBody,
              sentSMSID: this.sentSMSID,
              numbersArray: this.numbersArray,
              predefine:this.predefine
            },
            this.getAccessToken
          )
          .then((response) => {
            
            this.sentSMSID = null;
            this.numbersArray = [];
            this.$store.commit("setLoader", false);
            this.$emit("refresh-needed");
          });
      }
    },
    getNoteDateSelected(selectedDate) {
      this.selectedDate = selectedDate;
    },
  },
};
</script>

<style></style>
